module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/boxplus_logo-bea763f802ea3ebd82d3b1802715add8.svg";